@if (state.selectedItemType) {
  <div class="flex items-center gap-2">
    <span class="text-sm text-neutral-600">{{ 'examdojo.view' | transloco }}: </span>

    @if (badgeTypes.length > 1) {
      <dojo-button
        [size]="'s'"
        [mtxPopoverTriggerFor]="settings"
        [mtxPopoverTriggerOn]="'click'"
        [matTooltip]="'examdojo.customize_topics_list' | transloco"
        (popoverOpened)="focusActiveRadioButton()"
      >
        <span class="flex items-center gap-2">
          <span class="text-neutral-950">{{ BadgeTypeToLabelKey[state.selectedItemType] | transloco }}</span>
          <dojo-icon icon="chevron-down" />
        </span>
      </dojo-button>
    } @else {
      <div class="rounded border border-neutral-100 px-2 py-1">
        {{ BadgeTypeToLabelKey[state.selectedItemType] | transloco }}
      </div>
    }
  </div>
}

<mtx-popover #settings="mtxPopover" [position]="['after', 'below']" class="custom-mat-menu">
  <mat-radio-group
    aria-label="Select an option"
    class="radio-group-col"
    color="primary"
    [value]="state.selectedItemType"
  >
    @for (badgeType of badgeTypes; track badgeType) {
      <mat-radio-button [value]="badgeType" class="custom-mat-menu-item" (click)="badgeTypeChanged.emit(badgeType)">
        {{ BadgeTypeToLabelKey[badgeType] | transloco }}
      </mat-radio-button>
    }
  </mat-radio-group>
</mtx-popover>
